<h2>That’s it, you’re all set!</h2>
<p>
  We've sent you an email confirmation and your policy documents will follow shortly.
</p>
